// Datos de FACTURA de una cuenta de mesa (módulo ventas_restaurante): reglas puras del comprador,
// espejo de backend/services/fiscal.py (buyerError + tope de consumidor final). Las reglas del PAGO
// (forma, cuenta, voucher, propina, cambio) son las compartidas con el cobro de ventas: ver
// service/paymentRules.js.
import { round2 } from '../components/Accounting/accountEntryRules';

export const DEFAULT_FINAL_CONSUMER_LIMIT = 50;

export function finalConsumerAllowed(total, limit = DEFAULT_FINAL_CONSUMER_LIMIT) {
    return round2(total) < Number(limit);
}

export function emptyBuyer(total, limit) {
    return { mode: finalConsumerAllowed(total, limit) ? 'final' : 'data', id: null, identification: '',
             name: '', email: '', phoneNumber: '', address: '' };
}

const isPlaceholder = (id) => /^9+$/.test(id);

// ¿Por qué el SRI no aceptaría esta factura? {field, message} o null.
export function buyerError(buyer, total, limit = DEFAULT_FINAL_CONSUMER_LIMIT) {
    if (!buyer || buyer.mode !== 'data') {
        if (!finalConsumerAllowed(total, limit)) {
            return { field: 'customer', message: `Por reglamento del SRI, una factura de $${Number(limit).toFixed(0)} o más no puede ir a consumidor final: ingresa los datos del cliente.` };
        }
        return null;
    }
    const name = (buyer.name || '').trim();
    const identification = (buyer.identification || '').trim();
    if (!identification) return { field: 'identification', message: 'Escribe la cédula, el RUC o el pasaporte del cliente.' };
    if (isPlaceholder(identification)) return { field: 'identification', message: 'Esa identificación no es de un cliente real.' };
    if (/^\d+$/.test(identification) && ![10, 13].includes(identification.length)) {
        return { field: 'identification', message: 'La cédula tiene 10 dígitos y el RUC 13.' };
    }
    if (!name) return { field: 'name', message: 'Escribe el nombre del cliente.' };
    const email = (buyer.email || '').trim();
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return { field: 'email', message: 'El correo no es válido.' };
    return null;
}

// El comprador como lo espera el servidor (`orders._buyerPayload`); null = consumidor final.
export function buyerPayload(buyer) {
    if (!buyer || buyer.mode !== 'data') return null;
    const clean = (v) => (v || '').trim();
    return {
        id: buyer.id || null,
        identification: clean(buyer.identification),
        name: clean(buyer.name),
        email: clean(buyer.email) || null,
        phoneNumber: clean(buyer.phoneNumber) || null,
        address: clean(buyer.address),
    };
}

// ¿La identificación ya tiene el largo de una cédula o un RUC? (para buscar sola al terminar de escribir)
export function isLookupReady(identification) {
    const id = (identification || '').trim();
    return /^\d+$/.test(id) && (id.length === 10 || id.length === 13) && !isPlaceholder(id);
}
